import FormAnimation from '../../../../../FE/src/assets/javascripts/components/FormAnimation';

export default class ContentWithGravityForm {
  constructor(el) {
    this.$this = $(el);
    this.$form = this.$this.find('.careers-form__form');
    this.$header = $('header.header');
    this.$htmlBody = $('html, body');

    this.offsetSpace = 50;

    // Selectors for validation functionality
    this.selectors = {
      errorField: '.gfield_error',
      validationMessage: '.validation_message',
      gfield: '.gfield',
      errorFields: '.gfield_error input, .gfield_error textarea, .gfield_error select',
      captchaField: '.gfield--type-captcha',
      recaptchaContainer: '.ginput_recaptcha'
    };

    // Classes for validation functionality
    this.classes = {
      gfieldError: 'gfield_error',
      gfieldTypeEmail: 'gfield--type-email',
      gfieldTypePhone: 'gfield--type-phone',
      ginputPhone: 'ginput_phone',
      gfieldTypeCaptcha: 'gfield--type-captcha'
    };

    // Input types for validation
    this.inputTypes = {
      email: 'email',
      tel: 'tel'
    };

    if (!this.$form.length) { return; }
  }

  init() {
    this.initFormAnimation();
    this.addFormHandler();
    this.createCustomUploadInput();
    this.setupRecaptchaCallback();
  }

  addFormHandler() {
    $(document).on('gform_post_render', (event, formId) => {
      const $form = this.getFormElement(formId);

      if (!this.isInCareersForm($form)) {
        return;
      }

      // Re-initialize form animation after form re-render
      this.initFormAnimation();
      // Re-initialize custom upload inputs after form re-render
      this.createCustomUploadInput();
      // Handle validation clearing
      this.handleValidationClear();
      // Handle reCAPTCHA validation
      this.handleRecaptchaValidation();
      // Restart reCAPTCHA polling after form re-render
      this.restartRecaptchaPolling();

      const $errorFields = this.$form.find('.gfield_error');
      if (!$errorFields.length) { return; }

      const $firstErrorField = $errorFields.first();
      const $firstErrorFieldInput = $firstErrorField.find('input');
      const headerHeight = this.$header.outerHeight() || 0;

      this.$htmlBody.animate({
        scrollTop: $firstErrorField.offset().top - headerHeight - this.offsetSpace
      }, 500);

      $firstErrorFieldInput.length && $firstErrorFieldInput.focus();
    });
  }

  initFormAnimation() {
    new FormAnimation(this.$form);
  }

  handleValidationClear() {
    const errorFields = this.$this.find(this.selectors.errorFields);

    errorFields.each((_i, field) => {
      const $field = $(field);
      const $gfield = $field.closest(this.selectors.gfield);
      const validationText = $gfield.find(this.selectors.validationMessage).text().toLowerCase();
      const isRequiredError = validationText.includes('required');

      $field.off('input.validation change.validation blur.validation');

      const validateAndClear = () => {
        const fieldValue = $field.val();
        const isValid = this.validateField($field, fieldValue, isRequiredError);

        if (isValid) {
          this.clearFieldError($gfield, $field);
        }
      };

      $field.on('input.validation change.validation blur.validation', validateAndClear);
    });
  }

  validateField($field, value, isRequiredError) {
    const trimmedValue = value ? value.trim() : '';

    if (isRequiredError) {
      return trimmedValue !== '';
    }

    if (!trimmedValue) {
      return false;
    }

    const $gfield = $field.closest(this.selectors.gfield);
    const fieldType = $field.attr('type');
    const isEmailField = fieldType === this.inputTypes.email ||
      $gfield.hasClass(this.classes.gfieldTypeEmail);
    const isPhoneField = fieldType === this.inputTypes.tel ||
      $field.hasClass(this.classes.ginputPhone) ||
      $gfield.hasClass(this.classes.gfieldTypePhone);

    if (isEmailField) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedValue);
    }

    if (isPhoneField) {
      return trimmedValue.length >= 10;
    }

    return true;
  }

  clearFieldError($gfield, $field) {
    $gfield.removeClass(this.classes.gfieldError);
    $gfield.find(this.selectors.validationMessage).remove();
    $field.removeClass(this.classes.gfieldError);
    $field.attr('aria-invalid', 'false');
    $field.removeAttr('aria-describedby');
  }

  getFormElement(formId) {
    return $(`#gform_${formId}`);
  }

  isInCareersForm($element) {
    return $element.closest('.mod-careers-form').length > 0;
  }

  setupRecaptchaCallback() {
    // Wait for grecaptcha to be available
    const waitForGrecaptcha = () => {
      if (typeof grecaptcha !== 'undefined') {
        this.startRecaptchaPolling();
      } else {
        setTimeout(waitForGrecaptcha, 500);
      }
    };

    waitForGrecaptcha();
  }

  restartRecaptchaPolling() {
    // Stop existing polling intervals
    if (this.recaptchaPollInterval) {
      clearInterval(this.recaptchaPollInterval);
      this.recaptchaPollInterval = null;
    }
    if (this.recaptchaCheckInterval) {
      clearInterval(this.recaptchaCheckInterval);
      this.recaptchaCheckInterval = null;
    }
    // Start new polling
    this.startRecaptchaPolling();
  }

  startRecaptchaPolling() {
    let attempts = 0;
    const maxAttempts = 50; // 5 seconds max

    this.recaptchaCheckInterval = setInterval(() => {
      attempts++;
      const $recaptchaContainer = this.$this.find(this.selectors.recaptchaContainer);

      if ($recaptchaContainer.length) {
        const widgetId = $recaptchaContainer.attr('data-widget-id');

        if (widgetId !== undefined && widgetId !== '') {
          clearInterval(this.recaptchaCheckInterval);
          this.recaptchaCheckInterval = null;
          this.pollRecaptchaResponse(parseInt(widgetId));
        }
      }

      if (attempts >= maxAttempts) {
        clearInterval(this.recaptchaCheckInterval);
        this.recaptchaCheckInterval = null;
      }
    }, 100);
  }

  pollRecaptchaResponse(widgetId) {
    let lastResponse = '';
    let errorCount = 0;
    const maxErrors = 5;

    this.recaptchaPollInterval = setInterval(() => {
      if (typeof grecaptcha !== 'undefined') {
        try {
          const response = grecaptcha.getResponse(widgetId);

          // Reset error count on success
          errorCount = 0;

          if (response && response !== lastResponse) {
            lastResponse = response;
            this.handleRecaptchaValidation();
          }
        } catch (e) {
          errorCount++;

          // Stop polling if widget has been removed (form re-rendered)
          if (e.message.includes('removed') && errorCount >= maxErrors) {
            clearInterval(this.recaptchaPollInterval);
            this.recaptchaPollInterval = null;
          }
        }
      }
    }, 500);
  }

  handleRecaptchaValidation() {
    const $captchaFields = this.$this.find(`${this.selectors.captchaField}${this.selectors.errorField}`);

    $captchaFields.each((_i, field) => {
      const $gfield = $(field);
      const $recaptchaContainer = $gfield.find(this.selectors.recaptchaContainer);

      if ($recaptchaContainer.length) {
        const widgetId = $recaptchaContainer.attr('data-widget-id');

        // Check if recaptcha has been completed
        if (typeof grecaptcha !== 'undefined' && widgetId !== undefined) {
          try {
            const response = grecaptcha.getResponse(parseInt(widgetId));

            if (response) {
              $gfield.removeClass(this.classes.gfieldError);
              $gfield.find(this.selectors.validationMessage).remove();
            }
          } catch (e) {
            // Error checking reCAPTCHA
          }
        }
      }
    });
  }

  createCustomUploadInput() {
    const uploadInputs = this.$form.find('input[type="file"]');
    uploadInputs.each((_index, el) => {
      const $el = $(el);

      // Skip if already initialized
      if ($el.next('.custom-upload-input__button').length) {
        return;
      }

      const elementText = $el.attr('data-text') || 'SELECT FILES';
      const $button = $('<button type="button"></button>');
      $button.addClass('custom-upload-input__button pointer-events-auto btn btn-primary');
      const $fileText = $('<p></p>');
      $fileText.addClass('custom-upload-input__text hidden mb-0');

      // Set button text safely
      $button.text(elementText);

      $el.after($fileText);
      $el.after($button);

      $button.on('click', () => {
        $el.trigger('click');
      });

      // Handle file selection to display selected file name
      $el.on('change', (event) => {
        console.log('File input changed');
        const files = event.target.files;
         const iconTrash = `<button type="button" class="ml-2 custom-upload-input__clear-icon pointer-events-auto hover:text-states-300">
            <span class="dashicons dashicons-trash"  aria-hidden="true"></span><span class="sr-only">Clear selected file</span></button>`;
        if (files && files.length > 0) {
          if (files.length === 1) {
            // Single file - display the filename safely
            $fileText.text(files[0].name).removeClass('hidden');
            $fileText.append(iconTrash);
          } else {
            // Multiple files - display count safely
            $fileText.text(`${files.length} files selected`).removeClass('hidden');
          }
        } else {
          // No files selected - hide the element
          $fileText.text('').addClass('hidden');
        }
      });

      // Handle clear file button click
      $fileText.on('click', '.custom-upload-input__clear-icon', (event) => {
        event.preventDefault();
        event.stopPropagation();
        
        // Clear the file input value
        $el.val('');
        
        // Hide the file text and clear content
        $fileText.text('').addClass('hidden');
        
        // Trigger change event to update any other dependencies
        $el.trigger('change');
      });
    });
  }
}

$('.mod-careers-form').each((_index, el) => new ContentWithGravityForm(el).init());
